import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiMatIconCheckboxMenuComponent } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.component';

@Component({
    selector: 'fi-wrapper-table-mat-menu-cell',
    template: `
        <fi-mat-icon-checkbox-menu
            [buttonIconClass]="buttonIconClass"
            [actions]="actions"
            [value]="value"
            [subMenuClass]="subMenuClass"
            [matMenuClass]="'fi-wrapper-table-mat-menu ' + menuClass"
        >
        </fi-mat-icon-checkbox-menu>
    `,
    styleUrls: ['./fi-wrapper-table-mat-menu-cell.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-mat-menu-cell' },
    standalone: false,
})
export class FiWrapperTableMatMenuCellComponent<T> extends FiWrapperTableCellBase<T> implements OnInit, OnDestroy {
    @Input() buttonIconClass: string;
    @Input() actions: IItemsListAction2<T>[];
    @Input() menuClass: string = '';
    @Input() subMenuClass: string = '';
    @Input() actionsChanged$: Observable<void>;

    @ViewChild(FiMatIconCheckboxMenuComponent) matIconCheckboxMenuComponent: FiMatIconCheckboxMenuComponent<any>;

    constructor(private cdr: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        if (this.actionsChanged$) {
            this.actionsChanged$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((item) => {
                this.matIconCheckboxMenuComponent.detectChanges();
                this.cdr.markForCheck();
            });
        }
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
